import { OnboardingState } from '../models';

import { defaultInvite } from './invites';
import { defaultOrganization } from './organization';
import { defaultUpgrade } from './upgrade';

export const defaultState: OnboardingState = {
  ...defaultInvite,
  ...defaultUpgrade,
  ...defaultOrganization,
};
